import { render, staticRenderFns } from "./ParentCarerDetails.vue?vue&type=template&id=2e824c97&scoped=true&"
import script from "./ParentCarerDetails.vue?vue&type=script&lang=js&"
export * from "./ParentCarerDetails.vue?vue&type=script&lang=js&"
import style0 from "./ParentCarerDetails.vue?vue&type=style&index=0&id=2e824c97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e824c97",
  null
  
)

export default component.exports